export default __webpack_public_path__ + "static/media/wishlist1.303204f6.jpg";